export default "__VITE_ASSET__B9BuV4xb__"